import React, { useEffect, useState } from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";

import { Text, InputLabel } from "components";

import { colors, sizes } from "assets/constants";
import { removeArrayItemAt } from "utils";

type ItemT = { id: number; title: string; items: Array<FactorItemAttrT> };

type AttributesSelectorT = {
  items: Array<ItemT>;
  onChange: (items: Array<FactorItemAttrT>) => void;
  value?: Array<FactorItemAttrT>;
};

const AttributesSingleSelector: React.FC<AttributesSelectorT> = (props) => {
  const { items, value = null, onChange } = props;

  const [selectedItems, setSelectedItems] = useState<Array<FactorItemAttrT>>(
    value ?? []
  );

  useEffect(() => {
    if (selectedItems?.length === items?.length) {
      onChange(selectedItems);
    }
  }, [selectedItems]);

  useEffect(() => {
    if (value !== null) {
      setSelectedItems(value);
    }
  }, [value]);

  return (
    <>
      {items.map((item, key: number) => {
        return (
          <View style={{ marginTop: sizes.space }} key={String(key)}>
            <InputLabel
              label={item?.title}
              textProps={{ weight: "extraBold" }}
            />
            <View style={styles.container}>
              {item?.items?.map((attr, attrKey: number) => {
                const attrIndex = selectedItems?.findIndex(
                  (e) => e.id === attr.id
                );
                const isSelected = attrIndex > -1;

                const attrGroupIndex = selectedItems?.findIndex(
                  (e) => e.parent_id === item.id
                );

                const _onPress = () => {
                  if (isSelected) {
                    return;
                  }

                  if (attrGroupIndex > -1) {
                    const tmp = [...selectedItems];
                    tmp[attrGroupIndex] = { ...attr, parent_id: item?.id };
                    setSelectedItems(tmp);
                  } else {
                    setSelectedItems((prev) => [
                      ...prev,
                      { ...attr, parent_id: item.id },
                    ]);
                  }
                };

                return (
                  <TouchableOpacity
                    onPress={_onPress}
                    key={String(attrKey)}
                    style={{
                      ...styles.tag,
                      borderColor: isSelected
                        ? colors.theme
                        : colors.black + "09",
                      backgroundColor: isSelected ? colors.theme : colors.white,
                    }}
                  >
                    <Text
                      weight="bold"
                      color={isSelected ? colors.white : colors.text.normal}
                    >
                      {attr.title}
                    </Text>
                  </TouchableOpacity>
                );
              })}
            </View>
          </View>
        );
      })}
    </>
  );
};

export default AttributesSingleSelector;

const styles = StyleSheet.create({
  container: {
    flexWrap: "wrap",
    flexDirection: "row-reverse",
  },

  tag: {
    height: 35,
    borderWidth: 1,
    borderRadius: 15,
    marginBottom: sizes.space / 2,
    marginHorizontal: sizes.space / 2,
    paddingHorizontal: sizes.space,
    alignItems: "center",
    justifyContent: "center",
  },
});
